export default function TrustStrip() {
  const items = [
    {
      icon: 'ri-building-line',
      text: 'Built for service-based industries'
    },
    {
      icon: 'ri-lightbulb-line',
      text: 'Strategy-first, systems-driven'
    },
    {
      icon: 'ri-line-chart-line',
      text: 'Designed for measurable improvement'
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Trusted advisory approach'
    }
  ];

  return (
    <section className="py-16 bg-soft-silver">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-wealth-gold/10 rounded-full mb-4">
                <i className={`${item.icon} text-2xl text-wealth-gold`}></i>
              </div>
              <p className="text-sm font-medium text-slate-gray">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
